(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5704],{

/***/ 6338:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultation",
      function () {
        return __webpack_require__(2613);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ consultation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/common/index.ts + 9 modules
var common = __webpack_require__(108);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/ui/index.ts + 16 modules
var ui = __webpack_require__(4522);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/consultation/calendar.tsx




var Calendar = function() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var script = document.createElement("script");
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        document.body.appendChild(script);
        return function() {
            document.body.removeChild(script);
        };
    }, [
        router.events
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-7 lg:pt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* TextBold */.DU, {
                className: "text-xl",
                children: "Select a Date & Time"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-lg bg-colorFifteen p-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "calendly-inline-widget",
                    "data-url": "https://calendly.com/tucker-tub/free-consultation?hide_landing_page_details=1&hide_event_type_details=1&hide_gdpr_banner=1&background_color=fff7f0&text_color=014032&primary_color=014032",
                    style: {
                        height: "500px",
                        maxWidth: "560px"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/consultation/layout/body.tsx




var BodyContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* GradientWrap */.Mx, {
        className: "h-auto w-full bg-colorTwelve pt-0 font-haboro-soft text-colorFourteen lg:pt-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Wrapper */.im, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 gap-10 lg:grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "h-fit w-full rounded-lg p-8 font-haboro-soft shadow-consultation ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/assets/icons/Consultation-Clock.svg",
                                        alt: "Clock",
                                        width: "50px",
                                        height: "50px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                                            children: "Book a Free Consultation"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* TextBold */.DU, {
                                            className: "py-4",
                                            children: "Tucker Tub Consultation - 30 mins"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                            children: "Book your free consultation at a time that suits you best. A member of our team will call you at your selected time to understand your dog and discuss a feeding plan. You're one woof away from a healthier, happier pup!"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "m-auto grid w-[90%] grid-cols-1 gap-8 py-16 text-center text-base text-colorFourteen sm:grid-cols-2 lg:w-[60%]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-lg font-bold",
                                children: [
                                    "Already know what your dog needs? ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Head to the shop to find our range of natural dog food."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "m-auto w-[100%]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ButtonWithArrow */.Ub, {
                                href: "/shop",
                                buttonVariant: "primary",
                                center: true,
                                className: "m-auto w-[100%] lg:max-w-[240px]",
                                children: "Shop Dog Food"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/ui/cursive-basic.tsx
var cursive_basic = __webpack_require__(4693);
;// CONCATENATED MODULE: ./src/ui/circle-list.tsx

var CircleList = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-8 w-8 rounded-full ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/list-wrapper.tsx

var ListWrapper = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full flex gap-x-4 ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/consultation/circle-list-items.tsx



var CircleListItems = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full w-full space-y-3.5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleList, {
                        className: "bg-colorFourteen",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "flex justify-center text-center text-lg font-bold text-colorFifteen",
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-lg lg:text-list",
                        children: "Book a free consultation with our pet nutritionists"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleList, {
                        className: "bg-colorFourteen",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "flex justify-center text-center text-lg font-bold text-colorFifteen",
                            children: "2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-lg lg:text-list",
                        children: "Order food online in the Tucker Tub shop"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleList, {
                        className: "bg-colorFourteen",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "flex justify-center text-center text-lg font-bold text-colorFifteen",
                            children: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-lg lg:text-list",
                        children: "Delivered fresh to your door"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/consultation/layout/head.tsx




var HeadContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* BackgroundWrap */.e_, {
        className: "sliderimg bg-colorTwelve bg-consultation",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* GradientWrap */.Mx, {
            className: "from-colorTwelve via-colorTwelve to-transparent",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CurveBanner */.kq, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Header */.h4, {
                        className: "text-colorFourteen",
                        children: "Consultation"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Wrapper */.im, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[200px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                                    className: "text-colorFourteen",
                                    children: "Personalised Nutrition"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cursive_basic/* CursiveBasic */.x, {
                                    children: "Tailored just for your pup"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pt-5 pb-[30px] text-colorFifteen",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                            className: "text-colorFourteen",
                                            children: "Just like with humans, each dog's dietary needs is unique. There are tons of feeding plan generators and diets based on a dog's size. But so many factors play into your pup's optimal meal plan. We're firm believers that the best way to get your dog's perfect feeding plan is to hear directly from the experts. That's why we offer free consultations with our in-house pet nutritionists."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                            className: "text-colorFourteen",
                                            children: "Tucker Tub knows dogs, with over 25 years of experience making natural dog food. Over the years, we've learned what works best for them, and we're here to pass that knowledge on. Get your pup eating and living healthy in 3 easy steps."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleListItems, {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/consultation/index.tsx



var ConsultationContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadContent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyContent, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/consultation/index.tsx




var Consultation = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Consultation | Tucker Tub",
                description: "Tucker Tub's Consultation",
                openGraph: {
                    title: "Consultation | Tucker Tub",
                    description: "Tucker Tub's Consultation",
                    url: "https://preview.tuckertub.com.au",
                    type: "website",
                    locale: "en_AU",
                    site_name: "Tucker Tub"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Layout */.Ar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultationContent, {})
            })
        ]
    });
};
/* harmony default export */ var consultation = (Consultation);


/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CursiveBasic; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CursiveBasic = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "m-auto font-madelyn text-sliderTitle text-colorSixteen lg:text-blockHeader ".concat(className),
        children: children
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4507,236,5675,5812,8969,9774,2888,179], function() { return __webpack_exec__(6338); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);